import { ReasonInput } from '@strata/react-compound-inputs';
import { DialogWithForm } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { acknowledgePaymentDiscrepancy } from 'api/medbillingAPI';
import { handleError } from 'services/Error';
import { useRefetchAllClaimDetails } from 'store/api/medbillingApi';

const Title = 'Acknowledge Payment Discrepancy';

const ReasonOptions = [
    'Billing Issue',
    'Contract Rate',
    'Incorrect Referral Submitted',
    'Patient Responsibility',
    'Payer Issue',
    'Reference Price Issue',
];

const ValidationSchema = Yup.object({
    ...ReasonInput.validationSchema,
});

interface AcknowledgePaymentDiscrepancyDialogProps {
    onClose: () => void;
    payerId: string;
    transactionId: string;
}

export const AcknowledgePaymentDiscrepancyDialog = ({
    onClose,
    payerId,
    transactionId,
}: AcknowledgePaymentDiscrepancyDialogProps) => {
    const refetchAllClaimDetails = useRefetchAllClaimDetails({
        payerId,
        transactionId,
    });
    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            validateOnMount
            validationSchema={ValidationSchema}
            onSubmit={async (values, { resetForm }) => {
                try {
                    await acknowledgePaymentDiscrepancy({
                        transactionId,
                        payerId,
                        ...ReasonInput.submitValues(values),
                    });

                    refetchAllClaimDetails();

                    SuccessToast({ message: 'Payment discrepancy acknowledged.' });
                    resetForm();
                    onClose();
                } catch (err) {
                    handleError(
                        'Unable to acknowledged payment discrepancy. Please try again.',
                        err as Error,
                    );
                }
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    width={560}
                    isOpen
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={() => {
                        onClose();
                        formik.resetForm();
                    }}
                    primaryButtonLabel="Acknowledge Payment Discrepancy"
                    isPrimaryButtonDisabled={!formik.isValid || formik.isSubmitting}
                    dialogContent={
                        <>
                            <div className="margin__bottom--medium">
                                This action will remove the payment discrepancy indicator.
                            </div>
                            <ReasonInput reasons={ReasonOptions} />
                        </>
                    }
                />
            )}
        </Formik>
    );
};

AcknowledgePaymentDiscrepancyDialog.Title = Title;
